import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getUserList = async (params = {}) => {
  return await api.post("/v1/employee/getEmployeePaging", params);
};

export const getRoleOptions = async (params = {}) => {
  return await api.post("/v1/dropdown/getAllRoleByCompanyId", params);
};

export const getSupervisorOption = async (params = {}) => {
  return await api.post("/v1/supervisorManagement/getSupervisor", params);
};

export const getSupervisorListOption = async (params = {}) => {
  return await api.post("/v1/employee/getEmployeeInCompany", params);
};

export const updateUser = async (params = {}) => {
  return await api.post("/v1/user/updateUser", params);
};

export const manageStatus = async (params = {}) => {
  return await api.post("/v1/user/manageStatusUser", params);
};

export const getDropDown = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployee", params);
};

export const resetPassword = async (params = {}) => {
  return await apiFormData.post("/v1/password/forgot", params);
};

export const changePassword = async (params = {}) => {
  return await api.post("/v1/admin/changeStmUserBySuperAdmin", params);
};
